import React, { FunctionComponent, useState, useEffect } from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import useScrollPosition from '@react-hook/window-scroll';

import { Logo } from '..';
import style from './Header.module.less';

const HEIGHT = 76;

const getBrowserWidth = () => Math.max(
  document.body.scrollWidth,
  document.documentElement.scrollWidth,
  document.body.offsetWidth,
  document.documentElement.offsetWidth,
  document.documentElement.clientWidth
);

interface HeaderProps {
  transparentTop?: boolean;
}

export const Header: FunctionComponent<HeaderProps> = ({ transparentTop }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const [prevScrollY, setPrevScrollY] = useState<number | null>(null);
  const [offset, setOffset] = useState(0);
  const scrollY = useScrollPosition(60);

  useEffect(() => {
    // ignore the beginning
    if (prevScrollY === null) {
      setPrevScrollY(scrollY);
      return;
    }

    const diff = scrollY - prevScrollY;

    if (scrollY === 0) {
      // don't hide if on top or scrolled to top
      setOffset(0);
    } else if (diff > 0 && scrollY > 100 && getBrowserWidth() >= 760) {
      // scrolling down
      setOffset(Math.min(HEIGHT, offset + diff));
    } else {
      // scrolling up
      setOffset(0);
    }

    setPrevScrollY(scrollY);
  }, [scrollY]);

  return (
    <header
      className={classnames(style.header, scrollY === 0 && transparentTop && style.notScrolled)}
      style={{ top: `-${offset}px` }}
    >
      <div className={classnames(style.headerContainer, menuVisible && style.menuVisible)}>
        <div className={style.logo}>
          <Link to="/">
            <Logo className={style.headerLogo} />
            <Logo className={style.headerLogoMonochrome} monochrome />
            <span>Eleven <br />Puzzles</span>
          </Link>
        </div>

        <ul className={style.menu}>
          <li><Link activeClassName={style.active} to="/">Home</Link></li>
          <li className={style.expandable}>
            <Link activeClassName={style.active} to="/games" onClick={e => e.preventDefault()}>Games <span className={style.chevron}>⌵</span></Link>
            <ul>
              <li><Link activeClassName={style.active} to="/unsolved-case">Unsolved Case</Link></li>
              <li><Link activeClassName={style.active} to="/unboxing-the-cryptic-killer">Unboxing the Cryptic Killer</Link></li>
              <li><Link activeClassName={style.active} to="/parallel-experiment">Parallel Experiment</Link></li>
            </ul>
          </li>
          <li className={style.expandable}>
            <Link activeClassName={style.active} to="/web-games" onClick={e => e.preventDefault()}>Web Games <span className={style.chevron}>⌵</span></Link>
            <ul>
              <li><Link activeClassName={style.active} to="/web-games/unboxing-the-mind-of-a-cryptic-killer">Unboxing</Link></li>
              <li><Link activeClassName={style.active} to="/web-games/parallel-lab">Parallel Lab</Link></li>
            </ul>
          </li>
          {/* <li><Link activeClassName={style.active} to="/the-story">Story</Link></li> */}
          {/*<li><Link activeClassName={style.active} to="/how-to-play">How to play</Link></li>*/}
          {/*<li><Link activeClassName={style.active} to="/faq">FAQ</Link></li>*/}
          <li><Link activeClassName={style.active} to="/blog">Blog</Link></li>
          <li><Link activeClassName={style.active} to="/about-us">About us</Link></li>
          {/* <li className={style.buyItem}><button type="submit" className={style.buy} onClick={() => checkout()}>BUY</button></li> */}
        </ul>

        <button type="button" className={style.hamburger} onClick={() => setMenuVisible(!menuVisible)}>
          <svg width="24pt" height="24pt" version="1.1" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
            <path d="m16 17c-3.3125 0-6 2.6875-6 6s2.6875 6 6 6h68c3.3125 0 6-2.6875 6-6s-2.6875-6-6-6zm0 27c-3.3125 0-6 2.6875-6 6s2.6875 6 6 6h68c3.3125 0 6-2.6875 6-6s-2.6875-6-6-6zm0 27c-3.3125 0-6 2.6875-6 6s2.6875 6 6 6h68c3.3125 0 6-2.6875 6-6s-2.6875-6-6-6z"/>
          </svg>
        </button>
      </div>
    </header>
  );
};
